import { useQuery } from "@tanstack/react-query";
import { CacheKey } from "../models/cacheKey";
import { Response } from "../models/response";
import { CheckInProgress, CheckInProgressDto } from "../models/checkInProgress";
import HttpClient from "../utils/network";
import { OnSiteApi } from "../apis/onsite";

export function useCheckInStatus(
  artistId?: number,
  eventId?: number,
  rewardId?: number,
) {
  const {
    data: checkInProgress,
    isLoading,
    error,
    isError,
    refetch,
  } = useQuery({
    queryKey: [CacheKey.getCheckInStatus, eventId],
    queryFn: async () => {
      const response = new Response<CheckInProgressDto>(
        await HttpClient.request(
          OnSiteApi.checkInStatus(artistId!, eventId!, rewardId!),
        ),
      );
      return new CheckInProgress(response.data);
    },
    enabled:
      artistId !== undefined && eventId !== undefined && rewardId !== undefined,
  });

  return {
    checkInProgress: checkInProgress,
    isLoading,
    error,
    isError,
    refetch,
  };
}
